import React, { useState } from "react";
import AddClass from './class/addClass'
import DeleteClass from './class/deleteClass'
import SelectClass from './class/selectClass'
import Reports from "./class/reports";
import axios from 'axios';
import {axiosEH} from './common/functions'
import jwtUser from '../jwtUser';
import TableComp from './TableComp';
import './input.css'

export default function Class() {
  const BTN4 = 16, BTN3 = 8, BTN2 = 4, BTN1 = 2, BTN0 = 1;
  //const [statusMsg, setStatusMsg] = useState('You can replace the default class by selecting your class');
  const [statusMsg, setStatusMsg] = useState("You can select your own class");
  const [whichButton, setWhichButton] = useState(0x00);
  let [inputList, setInputList] = useState([{}]); // default type: [{}]
  const user = jwtUser(); // get user token

  function checkSelectedClassname() {
    const selectedClass = sessionStorage.getItem('selectedClassname');
    if (selectedClass != null) {
      setStatusMsg('');
      console.log('selectedClassname: ', selectedClass);
    } 
  }

  function getClasses(){
    const cl = sessionStorage.getItem('classList');
    if (cl ==''){
      setStatusMsg('No class, please click +Class to add a class');
      setInputList([]);
    } else {
      const clArr = JSON.parse(sessionStorage.getItem('classList'));
      setInputList([...clArr]);
    }

  }
       
  async function getUserClasses() {
    const url = process.env.REACT_APP_BASEURL + '/userclasses';
    axios.get(url, { headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {
        //console.log(JSON.stringify(res.data));
        if ( !Array.isArray(res.data) ) { // {}
          setStatusMsg(res.data.info);  // no class
          sessionStorage.setItem('classList', '');
          setInputList([]);
        } else {  // []
          //console.log(JSON.stringify(res.data));
          sessionStorage.setItem('classList', JSON.stringify(res.data));
          setInputList([...res.data]);
        }
      })
      .catch(err => { 
        setStatusMsg(axiosEH(err)); 
      })
  }
  // end of f()

  React.useEffect(() => {
    if (sessionStorage.getItem('classList') == null) {
      getUserClasses();
    } else {
      getClasses();
    }
    if (sessionStorage.getItem('classList') !='' ) checkSelectedClassname();
  }, []);   // render once only

  return (
    <div className="taskList mx-5">
      {inputList.length > 0 && <TableComp data={inputList} id="class-table" />}

      <span>
        {<button className="startButton " onClick={() => { setWhichButton(BTN0) }} >+Class</button>}
      </span> <span> </span>
      <span>
        {inputList.length > 0 && <button className="startButton" onClick={() => { setWhichButton(BTN1) }} >-Class</button>}
      </span>  <span></span>
      <span>
        {inputList.length > 0 && <button className="startButton " onClick={() => { setWhichButton(BTN2) }} >SelectClass</button>}
      </span> <span> </span>

      &nbsp;&nbsp;&nbsp;&nbsp;
      <span>
        {<button className="startButton " onClick={() => { setWhichButton(BTN4) }} >Reports</button>}
      </span> <span> </span>

      <br />
      {Boolean(whichButton & BTN0) && <  AddClass />}
      {Boolean(whichButton & BTN1) && <  DeleteClass />}
      {Boolean(whichButton & BTN2) && <  SelectClass />}
      {Boolean(whichButton & BTN4) && <  Reports />}
      {/*!Boolean(whichButton) && <label className="label has-text-success">{statusMsg}</label> */}
      <label className="label has-text-success">{statusMsg}</label>

    </div>
  );
}